exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dhyE7hsYQutABT5R_BFLJ{width:300px}html[dir] .dhyE7hsYQutABT5R_BFLJ{background-color:\"[theme:white, default:#ffffff]\"}._3yi9rDna-RygPN08uTksph{max-height:470px;overflow-x:hidden}._34jtJbHc4Kllh9nQjlPnTe{overflow:hidden}._2n9YOovSLChBl8p8WdJnHe{font-size:12px;font-weight:400}html[dir] ._2n9YOovSLChBl8p8WdJnHe{padding:4px}", ""]);

// exports
exports.locals = {
	"callout": "dhyE7hsYQutABT5R_BFLJ",
	"scrollContainer": "_3yi9rDna-RygPN08uTksph",
	"searchResultsCollection": "_34jtJbHc4Kllh9nQjlPnTe",
	"infoText": "_2n9YOovSLChBl8p8WdJnHe"
};